import {ref} from 'vue'
import {useAxiosCreate} from '@/backend/utils.js'
import authHeader from '@/backend/auth/auth-header';


class ApiConnector{

	constructor() {
    	this.api = useAxiosCreate('api');
    	this.settingsApi = useAxiosCreate('admin')
  	}

	getSettings(){
		const response = ref()
		const request = async ()=>{
			const res = await this.settingsApi.get('settings',{headers: authHeader()})
			response.value = res.data
		}
		return {response,request};
	}

	post(link,form){
		const response = ref()
		const request = async ()=>{
			const res = await this.api.post(link, form, {headers: authHeader()})
			response.value = res.data
		}
		return {response,request};
	}
	///Нужно
	get(link,params){
		const response = ref()
		const request = async ()=>{
			const res = await this.api.get(link,{params,headers: authHeader()})
			response.value = res.data
		}
		return {response,request}
	}

	getFile(link,form){
		const request = async ()=>{
			const res = await this.api.post(link,form,{headers: authHeader(),responseType: 'blob'})
			return res
		}
		return request()
	}

	getItems(link,params){
		
		const response = ref()
		const request = async ()=>{
			const res = await this.api.get(link,{params,headers: authHeader()})
			response.value = res.data
		}
		return {response,request}
	}
	///Нужно	
	getFilteredList(model, params){
		const response = ref();
		const request = async ()=> {
			const res = await this.api.get(model+'/list', {params, headers: authHeader()});
			response.value = res.data;
		}
		return {response, request};
	}

	getByParam(model,form){
		let url = model+'/search'
		const response = ref()
		const request = async ()=>{
			const res = await this.api.post(url, form, {headers: authHeader()})
			response.value = res.data
		}
		return {response,request}
	}

	put(link,form){
		const response = ref()
		const request = async ()=>{
			const res = await this.api.put(link, form, {headers: authHeader()})
			response.value = res.data
		}
		return {response,request};
	}

	delete(link,params){
		const response = ref()
		const request = async ()=>{
			const res = await this.api.delete(link,{params,headers: authHeader()})
			response.value = res.data
		}
		return {response,request};
	}

	getDatas(link){
		const response = ref()
		const request = async ()=>{
			const res = await this.api.get(link,{headers: authHeader()})
			response.value = res.data
		}
		return {response,request}
	}

	updateCustomerTable(link,file){
		const formData = new FormData();
    	formData.append('file', file);

		const response = ref()
		const request = async ()=>{
			const res = await this.api.post(link, formData, {
				headers: {
					...authHeader(),
				},
			})
			response.value = res.data
		}
		return {response,request}
	}

}


export default ApiConnector